import toggle from './nav-toggle.js'; import credits from './image-credit.js';
import './tabbing-navigation.js';
import SubmenuNavigation from './submenu-navigation.js';

import '../sass/style.scss';

( function( $ ) {

    $( document ).ready( function() {

        $( 'body' ).removeClass( 'no-js' );

        let Credits = new credits();
        Credits.init();

        let navToggle = new toggle();
        navToggle.init();

        let subNav = new SubmenuNavigation();
        subNav.init();

    });

})( jQuery );
